import styled from "styled-components"

export const StyledButton = styled.button`
  background: url(/assets/img/button.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  border: none;
  margin: 0.75em 0;
  cursor: pointer;
  font-size: 1.2em;
  font-weight: 600;
  padding: 4px 16px 4px 16px;
`
